import React from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'reactstrap'

import { MegaTagTitle } from 'components/Elements'
import { RegisterContainer, InfoContent } from 'features/auth/components'
import { ROLE } from 'features/user'
import image from 'assets/images/illustrations/search-job.png'

export const RegisterStudent = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'candidate_registration'} />

      <Row className="align-items-center h-100">
        <Col lg={5} className={'order-lg-first order-last'}>
          <div className={'mb-4'}>
            <InfoContent
              image={image}
              title={t('student_register_info_title')}
              text={t('student_register_info_text')}
            />
          </div>
        </Col>
        <Col lg={7}>
          <RegisterContainer role={ROLE.STUDENT} />
        </Col>
      </Row>
    </>
  )
}
